export default "__VITE_ASSET__sB2yquz1__"